import React from 'react';
import { Button } from './ui/Button';
export function MembershipTeaser() {
  return <section className="bg-[#F5F7FA] py-20 lg:py-28 font-heading" data-id="element-112">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-113">
        <h2 className="text-3xl md:text-4xl font-bold text-[#1B3A5C] mb-4 uppercase tracking-tight" data-id="element-114">
          Join the Hive — Membership Plans
        </h2>
        <p className="text-lg text-[#1E1E1E]/80 mb-8 font-medium" data-id="element-115">
          Save with recurring service plans. Lower rates, priority scheduling,
          and referral discounts.
        </p>

        <p className="text-[#1E1E1E] leading-relaxed mb-10 text-lg" data-id="element-116">
          We offer memberships with lower rates and monthly payment options. As
          a member, get scheduled services, additional discounts for referrals,
          and priority booking. Give us a buzz to see how we can sweeten the
          deal!
        </p>

        <Button className="bg-[#F5A623] hover:bg-[#E09520] text-[#1B3A5C] font-bold text-lg h-14 px-10 rounded-lg shadow-md hover:shadow-lg transition-all" data-id="element-117">
          View Membership Plans
        </Button>
      </div>
    </section>;
}